<app-theme-toggle></app-theme-toggle>

<!-- Page -->
<!-- Main -->
<div class="flex grow flex-col in-data-kt-[sticky-header=on]:pt-(--header-height)">
	<header app-header class="flex items-center shrink-0 bg-background h-(--header-height)" data-kt-sticky="true"
		data-kt-sticky-class="transition-[height] fixed z-10 top-0 left-0 right-0 shadow-xs backdrop-blur-md bg-white/70 dark:bg-coal-500/70 dark:border-b dark:border-b-light"
		data-kt-sticky-name="header" data-kt-sticky-offset="100px" id="header" data-kt-sticky-initialized="true">
	</header>

	<div app-navbar
		class="bg-muted hidden lg:flex lg:items-stretch border-y border-input lg:mb-10 [--kt-drawer-enable:true] lg:[--kt-drawer-enable:false]"
		data-kt-drawer="true"
		data-kt-drawer-class="kt-drawer kt-drawer-start fixed z-10 top-0 bottom-0 w-full me-5 max-w-[250px] p-5 lg:p-0 overflow-auto"
		id="navbar" data-kt-drawer-initialized="true">
	</div>

	<!-- Wrapper Container -->
	<div class="container-fixed w-full flex px-0">
		<!-- Content -->
		<main class="flex flex-col grow" id="content" role="content">
			<!-- Toolbar -->
			<div app-toolbar class="mb-5 lg:mb-7.5">
			</div> <!-- End of Toolbar -->
			<!-- Container -->
			<router-outlet></router-outlet>
			<!-- End of Container -->
			<!-- Footer -->
			<footer app-footer class="footer"></footer>
			<!-- End of Footer -->
		</main>
		<!-- End of Content -->
	</div>
	<!-- End of Page -->
</div>